import { FC, useContext } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { CCCreatePaymentMethodApiRequest } from 'components/features/creditCard/creditCardStore/types'
import AddPaymentMethodForm from 'components/features/creditCard/creditCardPanes/paneForms/AddPaymentMethodForm'
import Flex from 'components/atoms/Flex/Flex'
import { PaneContext } from 'components/features/pfm/FloatingPaneHost/FloatingPaneHost'
import { CreditCardFloatingPane } from 'components/features/creditCard/creditCardStore/floatingPane'

const PayCardMethodAddStep: FC<{ formContext: UseFormReturn<CCCreatePaymentMethodApiRequest>}> = ({ formContext }) => {
  const pane = useContext(PaneContext) as CreditCardFloatingPane

  return (
    <Flex padding='large-responsive'>
      <section>
        <h2>Add a payment method</h2>
        <p>
          Save a bank account you want to be able to use to make payments on your
          credit card.
        </p>
      </section>
      <AddPaymentMethodForm
        formContext={ formContext }
        paymentMode={ pane?.mode === 'autoPay' ? 'autoPay' : 'payCard' }
      />
      <small>
        By clicking 'Save Account', you are providing your electronic signature
        and authorizing us to debit your account.
      </small>
    </Flex>
  )
}

export default PayCardMethodAddStep
